﻿// Industry-specific options for 3MIQ
// Complete set of 12 industries with tailored dropdown options

export const INDUSTRIES = [
  { value: "entertainment", label: "Entertainment & Media" },
  { value: "technology", label: "Technology & Startups" },
  { value: "healthcare", label: "Healthcare & Wellness" },
  { value: "finance", label: "Finance & Business" },
  { value: "education", label: "Education & Research" },
  { value: "sports", label: "Sports & Athletics" },
  { value: "nonprofit", label: "Nonprofit & Social Impact" },
  { value: "entrepreneurship", label: "Entrepreneurship" },
  { value: "creative", label: "Creative Arts & Design" },
  { value: "environment", label: "Environment & Sustainability" },
  { value: "government", label: "Government & Public Service" },
  { value: "general", label: "General / No Specific Industry" }
];

export const INDUSTRY_OPTIONS = {
  entertainment: {
    experiences: [
      { value: "perform_stage", label: "Perform on stage or screen" },
      { value: "attend_premieres", label: "Attend major premieres & award shows" },
      { value: "create_content", label: "Create viral content or media" },
      { value: "collaborate_artists", label: "Collaborate with renowned artists" },
      { value: "festival_experiences", label: "Attend major festivals (Cannes, Sundance)" },
      { value: "record_music", label: "Record music or a podcast" },
      { value: "write_book", label: "Write and publish a book" },
      { value: "travel_world", label: "Travel the world" },
      { value: "artistic_expression", label: "Artistic expression & creativity" },
      { value: "entertainment_events", label: "Entertainment & live events" },
      { value: "social_connections", label: "Rich social connections" },
      { value: "financial_freedom", label: "Financial freedom & security" },
      { value: "dream_home", label: "Dream home & living space" },
      { value: "health_vitality", label: "Optimal health & vitality" },
      { value: "family_moments", label: "Meaningful family moments" }
    ],
    growth: [
      { value: "performance_skills", label: "Performance & presentation skills" },
      { value: "storytelling", label: "Storytelling & narrative craft" },
      { value: "creative_direction", label: "Creative direction & vision" },
      { value: "media_production", label: "Media production & technical skills" },
      { value: "brand_building", label: "Personal brand building" },
      { value: "music_performance", label: "Music performance & production" },
      { value: "public_speaking", label: "Public speaking & communication" },
      { value: "creative_thinking", label: "Creative & innovative thinking" },
      { value: "emotional_intelligence", label: "Emotional intelligence" },
      { value: "industry_networking", label: "Industry networking & relationships" },
      { value: "leadership", label: "Leadership & influence" },
      { value: "confidence_courage", label: "Confidence & courage" },
      { value: "strategic_thinking", label: "Strategic thinking & planning" },
      { value: "mental_resilience", label: "Mental resilience & adaptability" },
      { value: "financial_literacy", label: "Financial literacy & investing" }
    ],
    contribution: [
      { value: "inspire_through_art", label: "Inspire others through creative work" },
      { value: "diverse_representation", label: "Promote diverse representation in media" },
      { value: "mentor_artists", label: "Mentor emerging artists & creators" },
      { value: "cultural_storytelling", label: "Tell important cultural stories" },
      { value: "music_education", label: "Music & arts education access" },
      { value: "arts_culture", label: "Arts & cultural enrichment" },
      { value: "youth_empowerment", label: "Youth empowerment & education" },
      { value: "mental_health", label: "Mental health awareness & support" },
      { value: "thought_leadership", label: "Thought leadership & writing" },
      { value: "mentoring", label: "Mentoring & coaching others" },
      { value: "community_spaces", label: "Build community gathering spaces" },
      { value: "philanthropy", label: "Philanthropy & charitable giving" },
      { value: "volunteering", label: "Volunteering & community service" },
      { value: "workplace_culture", label: "Positive workplace culture" },
      { value: "social_justice", label: "Social justice & equality" }
    ]
  },
  
  technology: {
    experiences: [
      { value: "start_business", label: "Launch a tech startup" },
      { value: "travel_world", label: "Travel & work remotely worldwide" },
      { value: "financial_freedom", label: "Financial freedom through innovation" },
      { value: "collaborate_artists", label: "Collaborate with world-class engineers" },
      { value: "create_content", label: "Build products used by millions" },
      { value: "cultural_immersion", label: "Live in global tech hubs" },
      { value: "write_book", label: "Write a technical book" },
      { value: "health_vitality", label: "Optimal health & vitality" },
      { value: "social_connections", label: "Rich global network" },
      { value: "dream_home", label: "Dream home & workspace" },
      { value: "learn_instrument", label: "Master creative pursuits alongside tech" },
      { value: "adventure_sports", label: "Adventure & outdoor experiences" },
      { value: "family_moments", label: "Meaningful family moments" },
      { value: "artistic_expression", label: "Creative side projects & art" },
      { value: "luxury_experiences", label: "Luxury lifestyle experiences" }
    ],
    growth: [
      { value: "technical_mastery", label: "Technical mastery & deep expertise" },
      { value: "strategic_thinking", label: "Strategic thinking & systems design" },
      { value: "leadership", label: "Engineering leadership & management" },
      { value: "creative_thinking", label: "Product innovation & creative thinking" },
      { value: "financial_literacy", label: "VC, fundraising & financial literacy" },
      { value: "public_speaking", label: "Conference speaking & communication" },
      { value: "brand_building", label: "Thought leadership & personal brand" },
      { value: "negotiation", label: "Negotiation & business development" },
      { value: "emotional_intelligence", label: "Emotional intelligence & team dynamics" },
      { value: "industry_networking", label: "Tech community networking" },
      { value: "mental_resilience", label: "Startup resilience & adaptability" },
      { value: "mindfulness", label: "Mindfulness & focus practices" },
      { value: "reading_knowledge", label: "Reading & continuous learning" },
      { value: "physical_fitness", label: "Physical fitness & energy management" },
      { value: "language_learning", label: "Language learning for global reach" }
    ],
    contribution: [
      { value: "innovation", label: "Build technology that solves real problems" },
      { value: "technology_access", label: "Technology access & digital literacy" },
      { value: "education", label: "Tech education & coding bootcamps" },
      { value: "economic_development", label: "Job creation & economic development" },
      { value: "youth_empowerment", label: "Youth STEM empowerment" },
      { value: "environmental", label: "Climate tech & sustainability" },
      { value: "social_justice", label: "Tech for social justice & equity" },
      { value: "mentoring", label: "Mentor emerging developers" },
      { value: "thought_leadership", label: "Open source & knowledge sharing" },
      { value: "healthcare", label: "Health tech & medical innovation" },
      { value: "workplace_culture", label: "Build great engineering culture" },
      { value: "philanthropy", label: "Tech philanthropy & giving" },
      { value: "diverse_representation", label: "Diversity in tech" },
      { value: "community_spaces", label: "Build tech communities & meetups" },
      { value: "mental_health", label: "Mental health tech solutions" }
    ]
  },

  healthcare: {
    experiences: [
      { value: "health_vitality", label: "Achieve peak personal health & wellness" },
      { value: "travel_world", label: "Medical missions & global health travel" },
      { value: "spiritual_experiences", label: "Spiritual & healing retreats" },
      { value: "family_moments", label: "Deep family relationships & moments" },
      { value: "cultural_immersion", label: "Global healthcare system immersion" },
      { value: "write_book", label: "Write a medical or wellness book" },
      { value: "social_connections", label: "Meaningful professional relationships" },
      { value: "nature_wilderness", label: "Nature & outdoor restoration" },
      { value: "financial_freedom", label: "Financial security & independence" },
      { value: "dream_home", label: "Healing home environment" },
      { value: "culinary_adventures", label: "Nutritional & culinary exploration" },
      { value: "artistic_expression", label: "Creative expression & healing arts" },
      { value: "romantic_relationships", label: "Deep personal relationships" },
      { value: "learn_instrument", label: "Music & creative therapies" },
      { value: "adventure_sports", label: "Active outdoor experiences" }
    ],
    growth: [
      { value: "technical_mastery", label: "Clinical excellence & medical mastery" },
      { value: "emotional_intelligence", label: "Compassionate care & empathy" },
      { value: "leadership", label: "Healthcare leadership & administration" },
      { value: "public_speaking", label: "Medical communication & education" },
      { value: "mental_resilience", label: "Resilience & burnout prevention" },
      { value: "mindfulness", label: "Mindfulness-based stress reduction" },
      { value: "reading_knowledge", label: "Research & continuous medical education" },
      { value: "strategic_thinking", label: "Healthcare systems thinking" },
      { value: "negotiation", label: "Advocacy & policy negotiation" },
      { value: "physical_fitness", label: "Personal health & physical fitness" },
      { value: "language_learning", label: "Medical language & patient communication" },
      { value: "financial_literacy", label: "Healthcare business & financial literacy" },
      { value: "creative_thinking", label: "Medical innovation & problem-solving" },
      { value: "storytelling", label: "Patient storytelling & narrative medicine" },
      { value: "industry_networking", label: "Medical community networking" }
    ],
    contribution: [
      { value: "healthcare", label: "Direct patient care & healing" },
      { value: "mental_health", label: "Mental health awareness & support" },
      { value: "education", label: "Medical education & training" },
      { value: "innovation", label: "Medical research & innovation" },
      { value: "volunteering", label: "Free clinics & volunteer medicine" },
      { value: "environmental", label: "Environmental health & prevention" },
      { value: "social_justice", label: "Healthcare equity & access" },
      { value: "youth_empowerment", label: "Youth health education" },
      { value: "mentoring", label: "Mentor future healthcare professionals" },
      { value: "thought_leadership", label: "Public health thought leadership" },
      { value: "community_spaces", label: "Community health centers" },
      { value: "technology_access", label: "Health tech & telemedicine access" },
      { value: "family_legacy", label: "Generational health & family wellness" },
      { value: "philanthropy", label: "Medical philanthropy & global health" },
      { value: "diverse_representation", label: "Diversity in healthcare leadership" }
    ]
  },

  finance: {
    experiences: [
      { value: "financial_freedom", label: "Complete financial independence" },
      { value: "start_business", label: "Build a successful investment firm" },
      { value: "travel_world", label: "Travel the world with full freedom" },
      { value: "dream_home", label: "Dream homes in multiple locations" },
      { value: "luxury_experiences", label: "Luxury lifestyle & experiences" },
      { value: "social_connections", label: "Powerful professional network" },
      { value: "family_moments", label: "Generational family experiences" },
      { value: "cultural_immersion", label: "Global financial markets immersion" },
      { value: "write_book", label: "Write an investment or finance book" },
      { value: "health_vitality", label: "Premium health & longevity" },
      { value: "attend_premieres", label: "Elite events & exclusive access" },
      { value: "culinary_adventures", label: "Fine dining & culinary experiences" },
      { value: "adventure_sports", label: "High-end adventure experiences" },
      { value: "collaborate_artists", label: "Collaborate with industry legends" },
      { value: "artistic_expression", label: "Art collecting & patronage" }
    ],
    growth: [
      { value: "financial_literacy", label: "Investment mastery & wealth management" },
      { value: "strategic_thinking", label: "Strategic thinking & market analysis" },
      { value: "negotiation", label: "Negotiation & deal-making" },
      { value: "leadership", label: "Financial leadership & team building" },
      { value: "public_speaking", label: "Investor presentations & communication" },
      { value: "brand_building", label: "Personal brand & industry reputation" },
      { value: "reading_knowledge", label: "Economics, history & financial literature" },
      { value: "emotional_intelligence", label: "Client relationships & emotional intelligence" },
      { value: "technical_mastery", label: "Financial modeling & technical analysis" },
      { value: "mental_resilience", label: "Risk tolerance & mental resilience" },
      { value: "industry_networking", label: "Finance community & deal network" },
      { value: "creative_thinking", label: "Innovation in financial products" },
      { value: "mindfulness", label: "Decision clarity & mindfulness" },
      { value: "language_learning", label: "Language learning for global markets" },
      { value: "physical_fitness", label: "High performance health & fitness" }
    ],
    contribution: [
      { value: "economic_development", label: "Economic development & job creation" },
      { value: "philanthropy", label: "Philanthropy & strategic giving" },
      { value: "mentoring", label: "Mentor future finance professionals" },
      { value: "education", label: "Financial literacy education" },
      { value: "innovation", label: "Fintech innovation & disruption" },
      { value: "social_justice", label: "Impact investing & social finance" },
      { value: "community_spaces", label: "Community investment & development" },
      { value: "youth_empowerment", label: "Youth financial education" },
      { value: "thought_leadership", label: "Financial thought leadership" },
      { value: "technology_access", label: "Democratic access to investing" },
      { value: "family_legacy", label: "Family wealth & legacy building" },
      { value: "environmental", label: "ESG & sustainable investing" },
      { value: "diverse_representation", label: "Diversity in finance & investing" },
      { value: "healthcare", label: "Healthcare & biotech investment" },
      { value: "workplace_culture", label: "Great financial firm culture" }
    ]
  },

  education: {
    experiences: [
      { value: "travel_world", label: "Teach & learn across the world" },
      { value: "write_book", label: "Write influential educational books" },
      { value: "cultural_immersion", label: "Deep cultural learning experiences" },
      { value: "family_moments", label: "Meaningful family & community moments" },
      { value: "social_connections", label: "Rich intellectual community" },
      { value: "spiritual_experiences", label: "Philosophical & spiritual exploration" },
      { value: "financial_freedom", label: "Academic freedom & financial security" },
      { value: "create_content", label: "Create transformative learning content" },
      { value: "collaborate_artists", label: "Collaborate with brilliant thinkers" },
      { value: "nature_wilderness", label: "Nature-based learning & exploration" },
      { value: "artistic_expression", label: "Creative & intellectual expression" },
      { value: "health_vitality", label: "Sustainable energy & wellbeing" },
      { value: "dream_home", label: "Inspiring living & working environment" },
      { value: "adventure_sports", label: "Experiential & outdoor education" },
      { value: "record_music", label: "Educational media & podcast creation" }
    ],
    growth: [
      { value: "storytelling", label: "Educational storytelling & communication" },
      { value: "reading_knowledge", label: "Deep research & intellectual mastery" },
      { value: "leadership", label: "Educational leadership & administration" },
      { value: "creative_thinking", label: "Pedagogical innovation & creativity" },
      { value: "public_speaking", label: "Lecturing & public intellectual presence" },
      { value: "emotional_intelligence", label: "Student connection & empathy" },
      { value: "technical_mastery", label: "Subject matter expertise" },
      { value: "brand_building", label: "Academic reputation & influence" },
      { value: "strategic_thinking", label: "Curriculum design & systems thinking" },
      { value: "language_learning", label: "Language acquisition & multilingualism" },
      { value: "mindfulness", label: "Mindfulness & reflective practice" },
      { value: "industry_networking", label: "Academic & education community" },
      { value: "negotiation", label: "Grant writing & institutional advocacy" },
      { value: "mental_resilience", label: "Resilience in demanding academic work" },
      { value: "media_production", label: "Educational technology & digital tools" }
    ],
    contribution: [
      { value: "education", label: "Transform lives through teaching" },
      { value: "youth_empowerment", label: "Youth empowerment & development" },
      { value: "thought_leadership", label: "Academic thought leadership & research" },
      { value: "mentoring", label: "Mentor students & emerging scholars" },
      { value: "technology_access", label: "Educational technology access" },
      { value: "social_justice", label: "Education equity & access" },
      { value: "cultural_storytelling", label: "Preserve and share cultural knowledge" },
      { value: "diverse_representation", label: "Inclusive education & representation" },
      { value: "community_spaces", label: "Learning communities & spaces" },
      { value: "innovation", label: "Educational innovation & reform" },
      { value: "music_education", label: "Arts & music education" },
      { value: "environmental", label: "Environmental education & literacy" },
      { value: "family_legacy", label: "Generational education & learning culture" },
      { value: "mental_health", label: "Student mental health & wellbeing" },
      { value: "volunteering", label: "Community education & tutoring" }
    ]
  },

  sports: {
    experiences: [
      { value: "adventure_sports", label: "Compete at the highest athletic level" },
      { value: "travel_world", label: "Travel with sport worldwide" },
      { value: "health_vitality", label: "Peak physical performance & longevity" },
      { value: "financial_freedom", label: "Financial freedom through sport" },
      { value: "social_connections", label: "Legendary team relationships" },
      { value: "family_moments", label: "Inspiring family through sport" },
      { value: "cultural_immersion", label: "Sport as cross-cultural connection" },
      { value: "attend_premieres", label: "World championships & Olympics" },
      { value: "write_book", label: "Write your athletic story" },
      { value: "dream_home", label: "Dream training & living environment" },
      { value: "create_content", label: "Build a sports media platform" },
      { value: "collaborate_artists", label: "Collaborate with sport legends" },
      { value: "record_music", label: "Podcast, media & brand work" },
      { value: "start_business", label: "Build a sports business or brand" },
      { value: "artistic_expression", label: "Art, fashion & creative expression" }
    ],
    growth: [
      { value: "mental_resilience", label: "Mental toughness & competitive mindset" },
      { value: "physical_fitness", label: "Peak athletic conditioning" },
      { value: "leadership", label: "Team leadership & captaincy" },
      { value: "brand_building", label: "Athlete brand & media presence" },
      { value: "negotiation", label: "Contract negotiation & business deals" },
      { value: "emotional_intelligence", label: "Emotional control under pressure" },
      { value: "strategic_thinking", label: "Game strategy & tactical thinking" },
      { value: "public_speaking", label: "Media & public communication" },
      { value: "industry_networking", label: "Sports industry relationships" },
      { value: "financial_literacy", label: "Athlete financial management" },
      { value: "creative_thinking", label: "Innovation in training & performance" },
      { value: "mindfulness", label: "Mindfulness & sports psychology" },
      { value: "reading_knowledge", label: "Sports science & performance research" },
      { value: "storytelling", label: "Personal narrative & brand storytelling" },
      { value: "technical_mastery", label: "Technical skill refinement & mastery" }
    ],
    contribution: [
      { value: "youth_empowerment", label: "Youth sports & athletic development" },
      { value: "mentoring", label: "Mentor young athletes" },
      { value: "mental_health", label: "Athlete mental health advocacy" },
      { value: "community_spaces", label: "Community sports facilities & programs" },
      { value: "diverse_representation", label: "Diversity & inclusion in sport" },
      { value: "education", label: "Sport-based education programs" },
      { value: "social_justice", label: "Using sport as platform for change" },
      { value: "healthcare", label: "Sports medicine & athlete wellness" },
      { value: "economic_development", label: "Sport for community development" },
      { value: "philanthropy", label: "Athletic philanthropy & foundations" },
      { value: "environmental", label: "Sustainable sport & eco-athletics" },
      { value: "inspire_through_art", label: "Inspire through athletic excellence" },
      { value: "innovation", label: "Sports technology & performance innovation" },
      { value: "thought_leadership", label: "Sports thought leadership & commentary" },
      { value: "family_legacy", label: "Athletic family legacy & values" }
    ]
  },

  nonprofit: {
    experiences: [
      { value: "travel_world", label: "Volunteer & serve communities worldwide" },
      { value: "cultural_immersion", label: "Deep cross-cultural service experiences" },
      { value: "write_book", label: "Write about impact & social change" },
      { value: "family_moments", label: "Meaningful family & community moments" },
      { value: "social_connections", label: "Deep mission-aligned relationships" },
      { value: "spiritual_experiences", label: "Spiritual grounding & purpose retreats" },
      { value: "health_vitality", label: "Sustainable personal health & energy" },
      { value: "create_content", label: "Storytelling for social change" },
      { value: "collaborate_artists", label: "Collaborate with changemakers worldwide" },
      { value: "nature_wilderness", label: "Environmental connection & restoration" },
      { value: "financial_freedom", label: "Financial sustainability for mission work" },
      { value: "record_music", label: "Advocacy media & podcast" },
      { value: "artistic_expression", label: "Art as activism & expression" },
      { value: "dream_home", label: "Intentional community & living" },
      { value: "adventure_sports", label: "Active service & outdoor work" }
    ],
    growth: [
      { value: "leadership", label: "Nonprofit leadership & executive management" },
      { value: "storytelling", label: "Impact storytelling & fundraising narrative" },
      { value: "emotional_intelligence", label: "Empathy, trauma-informed approaches" },
      { value: "negotiation", label: "Grant writing & partnership negotiation" },
      { value: "public_speaking", label: "Advocacy & public speaking" },
      { value: "strategic_thinking", label: "Theory of change & systems thinking" },
      { value: "brand_building", label: "Organizational brand & communications" },
      { value: "mental_resilience", label: "Resilience in mission-driven work" },
      { value: "financial_literacy", label: "Nonprofit financial management" },
      { value: "industry_networking", label: "Philanthropy & NGO community" },
      { value: "creative_thinking", label: "Innovative program design" },
      { value: "reading_knowledge", label: "Social science & policy research" },
      { value: "mindfulness", label: "Mindfulness & compassion fatigue prevention" },
      { value: "technical_mastery", label: "Program evaluation & impact measurement" },
      { value: "language_learning", label: "Language for cross-cultural service" }
    ],
    contribution: [
      { value: "social_justice", label: "Systemic social justice & equity" },
      { value: "volunteering", label: "Direct community service & volunteerism" },
      { value: "youth_empowerment", label: "Youth development & education" },
      { value: "mental_health", label: "Mental health & trauma support" },
      { value: "environmental", label: "Environmental justice & conservation" },
      { value: "economic_development", label: "Economic empowerment for underserved" },
      { value: "healthcare", label: "Community health access" },
      { value: "education", label: "Education equity & access" },
      { value: "mentoring", label: "Individual mentoring & coaching" },
      { value: "community_spaces", label: "Safe community spaces" },
      { value: "diverse_representation", label: "Representation & inclusion" },
      { value: "cultural_storytelling", label: "Preserve marginalized cultural stories" },
      { value: "family_legacy", label: "Intergenerational healing & legacy" },
      { value: "philanthropy", label: "Mobilize philanthropic resources" },
      { value: "innovation", label: "Social innovation & systems change" }
    ]
  },

  entrepreneurship: {
    experiences: [
      { value: "start_business", label: "Build a category-defining company" },
      { value: "financial_freedom", label: "Complete financial independence" },
      { value: "travel_world", label: "Build & travel simultaneously" },
      { value: "collaborate_artists", label: "Partner with world-class co-founders" },
      { value: "write_book", label: "Write your entrepreneurial story" },
      { value: "social_connections", label: "Powerful founder community" },
      { value: "create_content", label: "Build a thought leadership platform" },
      { value: "cultural_immersion", label: "Global market immersion" },
      { value: "attend_premieres", label: "Major conferences & product launches" },
      { value: "dream_home", label: "Dream workspace & living environment" },
      { value: "luxury_experiences", label: "Earned luxury through building" },
      { value: "family_moments", label: "Family freedom & presence" },
      { value: "record_music", label: "Podcast & personal brand media" },
      { value: "health_vitality", label: "High-performance health" },
      { value: "artistic_expression", label: "Creative vision & product design" }
    ],
    growth: [
      { value: "leadership", label: "Founder leadership & vision" },
      { value: "strategic_thinking", label: "Business strategy & market insight" },
      { value: "negotiation", label: "Fundraising, sales & negotiation" },
      { value: "brand_building", label: "Personal & company brand building" },
      { value: "mental_resilience", label: "Founder resilience & perseverance" },
      { value: "public_speaking", label: "Pitching, speaking & storytelling" },
      { value: "financial_literacy", label: "VC, cap tables & financial modeling" },
      { value: "creative_thinking", label: "Product innovation & problem-solving" },
      { value: "emotional_intelligence", label: "Team building & culture creation" },
      { value: "industry_networking", label: "Investor & founder community" },
      { value: "technical_mastery", label: "Domain expertise in your field" },
      { value: "reading_knowledge", label: "Business literature & mental models" },
      { value: "mindfulness", label: "Clarity & decision-making under pressure" },
      { value: "storytelling", label: "Narrative & company storytelling" },
      { value: "language_learning", label: "Language for global expansion" }
    ],
    contribution: [
      { value: "economic_development", label: "Job creation & economic growth" },
      { value: "innovation", label: "Industry disruption & innovation" },
      { value: "mentoring", label: "Mentor aspiring entrepreneurs" },
      { value: "youth_empowerment", label: "Youth entrepreneurship programs" },
      { value: "thought_leadership", label: "Entrepreneurship thought leadership" },
      { value: "technology_access", label: "Democratize access through products" },
      { value: "social_justice", label: "Mission-driven business & social enterprise" },
      { value: "education", label: "Entrepreneurship education" },
      { value: "diverse_representation", label: "Diverse founder representation" },
      { value: "community_spaces", label: "Build entrepreneurial ecosystems" },
      { value: "environmental", label: "Sustainable business practices" },
      { value: "philanthropy", label: "Founder philanthropy & giving pledge" },
      { value: "family_legacy", label: "Business dynasty & family legacy" },
      { value: "workplace_culture", label: "Build exceptional company culture" },
      { value: "healthcare", label: "Healthcare & wellbeing innovation" }
    ]
  },

  creative: {
    experiences: [
      { value: "artistic_expression", label: "Create iconic works of art" },
      { value: "travel_world", label: "Travel as creative fuel & inspiration" },
      { value: "cultural_immersion", label: "Deep cultural & artistic immersion" },
      { value: "collaborate_artists", label: "Collaborate with creative legends" },
      { value: "festival_experiences", label: "Major art & design festivals worldwide" },
      { value: "write_book", label: "Write & publish creative works" },
      { value: "record_music", label: "Record music & creative media" },
      { value: "perform_stage", label: "Perform or exhibit your work publicly" },
      { value: "financial_freedom", label: "Financial freedom through creative work" },
      { value: "social_connections", label: "Vibrant creative community" },
      { value: "dream_home", label: "Dream creative studio & living space" },
      { value: "family_moments", label: "Family inspiration & creative legacy" },
      { value: "spiritual_experiences", label: "Spiritual & meditative creative practice" },
      { value: "culinary_adventures", label: "Sensory experiences as creative input" },
      { value: "luxury_experiences", label: "Luxury & aesthetic living" }
    ],
    growth: [
      { value: "artistic_skills", label: "Mastery of your creative craft" },
      { value: "creative_direction", label: "Creative direction & artistic vision" },
      { value: "storytelling", label: "Narrative & storytelling mastery" },
      { value: "creative_thinking", label: "Conceptual thinking & ideation" },
      { value: "brand_building", label: "Artist brand & market positioning" },
      { value: "technical_mastery", label: "Technical craft & execution" },
      { value: "media_production", label: "Media production & publishing" },
      { value: "industry_networking", label: "Creative industry relationships" },
      { value: "public_speaking", label: "Artist talks & creative communication" },
      { value: "emotional_intelligence", label: "Emotional depth & authenticity" },
      { value: "financial_literacy", label: "Creative business & licensing" },
      { value: "mental_resilience", label: "Creative resilience & persistence" },
      { value: "mindfulness", label: "Mindfulness for creative flow" },
      { value: "reading_knowledge", label: "Art history, theory & creative literature" },
      { value: "language_learning", label: "Language for cross-cultural creative work" }
    ],
    contribution: [
      { value: "inspire_through_art", label: "Inspire & transform through art" },
      { value: "arts_culture", label: "Enrich community cultural life" },
      { value: "education", label: "Creative education & arts teaching" },
      { value: "diverse_representation", label: "Diverse voices in creative fields" },
      { value: "cultural_storytelling", label: "Preserve & celebrate cultural stories" },
      { value: "music_education", label: "Arts education & creative access" },
      { value: "mentoring", label: "Mentor emerging creative talent" },
      { value: "community_spaces", label: "Build creative community spaces" },
      { value: "mental_health", label: "Art as healing & mental health support" },
      { value: "thought_leadership", label: "Creative thought leadership & criticism" },
      { value: "social_justice", label: "Art as activism & social commentary" },
      { value: "environmental", label: "Environmental art & eco-creativity" },
      { value: "youth_empowerment", label: "Youth arts & creative empowerment" },
      { value: "philanthropy", label: "Arts philanthropy & patronage" },
      { value: "innovation", label: "Creative innovation & design thinking" }
    ]
  },

  environment: {
    experiences: [
      { value: "nature_wilderness", label: "Deep wilderness & nature immersion" },
      { value: "travel_world", label: "Explore intact natural ecosystems worldwide" },
      { value: "adventure_sports", label: "Eco-adventures & outdoor pursuits" },
      { value: "spiritual_experiences", label: "Nature-based spiritual practice" },
      { value: "cultural_immersion", label: "Indigenous & traditional ecological knowledge" },
      { value: "write_book", label: "Write about nature & sustainability" },
      { value: "health_vitality", label: "Nature-connected health & vitality" },
      { value: "family_moments", label: "Raise nature-connected family" },
      { value: "social_connections", label: "Global conservation community" },
      { value: "financial_freedom", label: "Sustainable financial independence" },
      { value: "create_content", label: "Environmental media & storytelling" },
      { value: "dream_home", label: "Sustainable living environment" },
      { value: "collaborate_artists", label: "Collaborate with environmental scientists" },
      { value: "record_music", label: "Environmental podcast & media" },
      { value: "artistic_expression", label: "Nature-inspired art & expression" }
    ],
    growth: [
      { value: "technical_mastery", label: "Environmental science & ecology mastery" },
      { value: "strategic_thinking", label: "Systems thinking & sustainability strategy" },
      { value: "public_speaking", label: "Environmental advocacy & communication" },
      { value: "leadership", label: "Conservation leadership & management" },
      { value: "storytelling", label: "Environmental storytelling & narrative" },
      { value: "creative_thinking", label: "Sustainable innovation & design" },
      { value: "negotiation", label: "Policy negotiation & advocacy" },
      { value: "reading_knowledge", label: "Environmental science & climate research" },
      { value: "industry_networking", label: "Conservation & sustainability community" },
      { value: "brand_building", label: "Environmental thought leadership" },
      { value: "financial_literacy", label: "Green finance & impact investing" },
      { value: "emotional_intelligence", label: "Community engagement & empathy" },
      { value: "language_learning", label: "Language for global environmental work" },
      { value: "mindfulness", label: "Mindfulness in nature & eco-psychology" },
      { value: "mental_resilience", label: "Resilience amid climate anxiety" }
    ],
    contribution: [
      { value: "environmental", label: "Direct conservation & restoration" },
      { value: "innovation", label: "Clean technology & sustainable innovation" },
      { value: "education", label: "Environmental education & literacy" },
      { value: "social_justice", label: "Environmental justice & equity" },
      { value: "cultural_storytelling", label: "Indigenous ecological knowledge preservation" },
      { value: "thought_leadership", label: "Climate thought leadership & policy" },
      { value: "youth_empowerment", label: "Youth environmental empowerment" },
      { value: "community_spaces", label: "Community green spaces & gardens" },
      { value: "volunteering", label: "Conservation volunteering & restoration" },
      { value: "diverse_representation", label: "Diversity in environmental leadership" },
      { value: "mentoring", label: "Mentor young conservationists" },
      { value: "philanthropy", label: "Environmental philanthropy & activism" },
      { value: "healthcare", label: "Environmental health & prevention" },
      { value: "economic_development", label: "Green economy & sustainable livelihoods" },
      { value: "technology_access", label: "Green technology access" }
    ]
  },

  government: {
    experiences: [
      { value: "travel_world", label: "Diplomatic travel & global engagement" },
      { value: "write_book", label: "Write about policy & public service" },
      { value: "social_connections", label: "Powerful civic relationships" },
      { value: "cultural_immersion", label: "Cross-cultural diplomatic experiences" },
      { value: "family_moments", label: "Meaningful family amid public service" },
      { value: "financial_freedom", label: "Post-service financial independence" },
      { value: "attend_premieres", label: "Historic moments & state events" },
      { value: "collaborate_artists", label: "Work with world leaders & changemakers" },
      { value: "spiritual_experiences", label: "Purpose & calling in public service" },
      { value: "health_vitality", label: "Sustained energy for demanding work" },
      { value: "record_music", label: "Policy media & communication platform" },
      { value: "artistic_expression", label: "Creative expression & intellectual life" },
      { value: "create_content", label: "Public communication & civic media" },
      { value: "dream_home", label: "Home as sanctuary from public life" },
      { value: "start_business", label: "Post-service entrepreneurship" }
    ],
    growth: [
      { value: "public_speaking", label: "Oratory, debate & public communication" },
      { value: "strategic_thinking", label: "Policy strategy & systems thinking" },
      { value: "negotiation", label: "Diplomacy & political negotiation" },
      { value: "leadership", label: "Public leadership & governance" },
      { value: "emotional_intelligence", label: "Constituent empathy & civic service" },
      { value: "reading_knowledge", label: "Law, history & political science" },
      { value: "industry_networking", label: "Civic & political community" },
      { value: "mental_resilience", label: "Resilience under public scrutiny" },
      { value: "brand_building", label: "Public reputation & civic brand" },
      { value: "storytelling", label: "Narrative & political communication" },
      { value: "language_learning", label: "Language for international diplomacy" },
      { value: "financial_literacy", label: "Budget policy & economic literacy" },
      { value: "creative_thinking", label: "Policy innovation & creative governance" },
      { value: "mindfulness", label: "Clarity & composure in high-stakes work" },
      { value: "technical_mastery", label: "Policy domain expertise" }
    ],
    contribution: [
      { value: "social_justice", label: "Justice, equity & civil rights" },
      { value: "economic_development", label: "Economic policy & development" },
      { value: "education", label: "Education policy & reform" },
      { value: "healthcare", label: "Public health policy" },
      { value: "environmental", label: "Environmental policy & climate legislation" },
      { value: "innovation", label: "Government innovation & modernization" },
      { value: "diverse_representation", label: "Representative democracy & inclusion" },
      { value: "community_spaces", label: "Public spaces & infrastructure" },
      { value: "youth_empowerment", label: "Youth civic engagement" },
      { value: "thought_leadership", label: "Public policy thought leadership" },
      { value: "mentoring", label: "Mentor future public servants" },
      { value: "philanthropy", label: "Civic philanthropy & public good" },
      { value: "technology_access", label: "Digital government & public tech" },
      { value: "family_legacy", label: "Public service family legacy" },
      { value: "mental_health", label: "Public mental health & wellbeing" }
    ]
  },

  general: {
    experiences: [
      { value: "travel_world", label: "Travel the world" },
      { value: "adventure_sports", label: "Adventure sports & activities" },
      { value: "cultural_immersion", label: "Cultural immersion experiences" },
      { value: "family_moments", label: "Meaningful family moments" },
      { value: "romantic_relationships", label: "Deep romantic relationships" },
      { value: "social_connections", label: "Rich social connections" },
      { value: "financial_freedom", label: "Financial freedom & security" },
      { value: "health_vitality", label: "Optimal health & vitality" },
      { value: "dream_home", label: "Dream home & living space" },
      { value: "artistic_expression", label: "Artistic expression & creativity" },
      { value: "spiritual_experiences", label: "Spiritual experiences & retreats" },
      { value: "write_book", label: "Write and publish a book" },
      { value: "start_business", label: "Start your own business" },
      { value: "nature_wilderness", label: "Nature & wilderness experiences" },
      { value: "luxury_experiences", label: "Luxury lifestyle experiences" }
    ],
    growth: [
      { value: "leadership", label: "Leadership & influence" },
      { value: "emotional_intelligence", label: "Emotional intelligence" },
      { value: "public_speaking", label: "Public speaking & communication" },
      { value: "creative_thinking", label: "Creative & innovative thinking" },
      { value: "physical_fitness", label: "Physical fitness & strength" },
      { value: "mental_resilience", label: "Mental resilience & adaptability" },
      { value: "financial_literacy", label: "Financial literacy & investing" },
      { value: "reading_knowledge", label: "Reading & knowledge acquisition" },
      { value: "strategic_thinking", label: "Strategic thinking & planning" },
      { value: "confidence_courage", label: "Confidence & courage" },
      { value: "empathy_compassion", label: "Empathy & compassion" },
      { value: "storytelling", label: "Storytelling & narrative craft" },
      { value: "negotiation", label: "Negotiation & persuasion" },
      { value: "brand_building", label: "Personal brand building" },
      { value: "mindfulness", label: "Mindfulness & meditation" }
    ],
    contribution: [
      { value: "mentoring", label: "Mentoring & coaching others" },
      { value: "volunteering", label: "Volunteering & community service" },
      { value: "environmental", label: "Environmental conservation" },
      { value: "education", label: "Education & teaching" },
      { value: "healthcare", label: "Healthcare & wellness support" },
      { value: "innovation", label: "Innovation & problem-solving" },
      { value: "social_justice", label: "Social justice & equality" },
      { value: "family_legacy", label: "Family legacy & heritage" },
      { value: "workplace_culture", label: "Positive workplace culture" },
      { value: "philanthropy", label: "Philanthropy & charitable giving" },
      { value: "youth_empowerment", label: "Youth empowerment" },
      { value: "mental_health", label: "Mental health awareness" },
      { value: "diverse_representation", label: "Diversity & representation" },
      { value: "community_spaces", label: "Build community spaces" },
      { value: "economic_development", label: "Economic development" }
    ]
  }
};

export const getOptionsForIndustry = (industry) => {
  return INDUSTRY_OPTIONS[industry] || INDUSTRY_OPTIONS.general;
};
